import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAuthForm, LazyButton, LazyCard, LazyConfirmationModal, LazyCopyText, LazyDeleteConfirmationModal, LazyDropdownMenu, LazyFlowStepper, LazyGlobalModalContainer, LazyHamburgerMenu, LazyInputCustom, LazyInputRange, LazyIntroVideoModal, LazyLoading, LazyLogo, LazyLogoName, LazyModalContainer, LazyPaddleInlineCheckout, LazyPage, LazyPageLoading, LazyPlanSelector, LazyProgressBar, LazyProgressStepper, LazyScrim, LazySearchableDropdown, LazyTablePagination, LazyTextAreaCustom, LazyToast, LazyTrialBanner, LazyTurnstileWidget, LazyTypedConfirmationModal, LazyUnsavedChangesModal, LazyUpgradePlanModal, LazyAuditBusinessImpact, LazyAuditChallenges, LazyAuditCompanyDetails, LazyAuditContainer, LazyAuditPolicies, LazyAuditReport, LazyAuditStepper, LazyAuditSummary, LazyAuditWelcome, LazyAuditWelcomeInline, LazyCostPerTechnicalHire, LazyDropdownQuestion, LazyFaqModal, LazyFrequencyScale, LazyFrequencyScaleQuestion, LazyHiringProcessCreate, LazyInterviewDuration, LazyInterviewLocation, LazyInterviewParticipantCount, LazyInterviewType, LazyLongestTimeToHire, LazyMarketRateTarget, LazyNumberOfEmployees, LazyNumberOfRecruiters, LazyNumberOfTechnicalEmployees, LazyNumberOfTechnicalHiresLast12Months, LazyNumberOfTechnicalHiresNext12Months, LazyNumberQuestion, LazyOfferAcceptanceRate, LazyProcessStageTable, LazyProgressDial, LazyRadioGroup, LazySectionHeader, LazySelectionCard, LazySelectionCardContainer, LazyStep0, LazyStep1, LazyStep2, LazyStep3, LazyStep4, LazyStep5, LazyStep7, LazySubQuestionGroup, LazyTimeToFillPosition, LazyYesNoAuditQuestionsContainer, LazyYesNoButtons, LazyYesNoQuestion, LazyYesNoSelect, LazySSOLoginButton, LazyAiBadge, LazyInfoTooltip, LazyNotificationDropdown, LazyDashboardActionCard, LazyEmptyStateCard, LazyKpiCard, LazyRecentDocumentCard, LazyFeedbackModal, LazyDynamicForm, LazyFormContainer, LazyFormFlag, LazyCompanyInfoSchema, LazyPositionSchema1, LazyHelpPage, LazyTabHeading, LazyAuditImprovementComparison, LazyCandidatePacket, LazyFeatureCard, LazyHiringKitTabs, LazyIntakeSummary, LazyInternalSummaryReport, LazyInterviewPlanSummary, LazyInterviewStagesPdf, LazyJobDescriptionModal, LazyLinkedInBooleanSearch, LazyLinkedinBooleanSearchModal, LazyMetricBox, LazyPdfBrand, LazyPdfSectionChecklist, LazyPdfSensitiveControls, LazyPdfSnapshotDialog, LazyRiskWarningSlideover, LazyRolePlanPdfSections, LazyRolePlanSave, LazyTabContent, LazyUsefulLinks, LazyInterviewStrategyTable, LazyInterviewTypeCard, LazyMatrixSlider, LazyMatrixTable, LazyModelCard, LazyRegionCard, LazyWorldMap, LazyCheckerPanel, LazyIntakeComplete, LazyIntakeFormField, LazyIntakeFormSection, LazyIntakeLayout, LazyIntakeMobileSteps, LazyIntakeSidebar, LazyIntakeStepModal, LazyIntakeStepper, LazyIntakeWelcome, LazyInterviewPlanStep, LazyRadioSelect, LazyReadOnlyIntakeSections, LazySalaryMarketCheck, LazyYesNoRadio, LazyFocusAreaConditionalSection, LazyImpactModelInputs, LazyImpactModelSummary, LazyInterviewMetricsRow, LazyInterviewPlanReadyModal, LazyInterviewPlanSelection, LazyInterviewStageCard, LazyInterviewStageModal, LazyYogenPlanConfirmModal, LazyLeftNav, LazyLeftNavLink, LazyNavBar, LazyProfileMenu, LazyJobDescription, LazyUnicornCheckerModal, LazyUnicornCheckerPanel, LazyAddHiringProcessModal, LazyHiringProcessDisplay, LazyCompanyInfo, LazyCompanyInfoEditModal, LazyCompanyInfoIntakeDisplay, LazyCompanyInfoIntakeForm, LazyCompanyInfoProfileSection, LazyOrgInfo, LazyProfileContainer, LazyTeamInfo, LazyUserInfo, LazyAdministration, LazyAuditLogs, LazyChangePassword, LazyDeleteAccount, LazyInviteUserModal, LazyMFASettings, LazyManageUsers, LazyMemberAccessEditor, LazyMemberAccessModal, LazyOIDCSettings, LazyOrgSettings, LazyPrivacySettings, LazyRevokeAccessModal, LazyRolesPermissionsModal, LazySeatLimitModal, LazySecuritySettings, LazySessionTimeoutSettings, LazyTeamCreateModal, LazyTeamMembersManager, LazyMockInterviewStepper, LazyCandidateStatus, LazyChatWindow, LazyDifficInterviewtoolkit, LazyHeartRateIndicator, LazyInterviewtoolkit, LazyTimeRemaining, LazyMockInterviewCandidateStep, LazyMockInterviewDetailsStep, LazyMockInterviewRoleStep, LazyVChipWrapper, LazyVDataTableWrapper, LazyVIconWrapper } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AuthForm", LazyAuthForm],
["Button", LazyButton],
["Card", LazyCard],
["ConfirmationModal", LazyConfirmationModal],
["CopyText", LazyCopyText],
["DeleteConfirmationModal", LazyDeleteConfirmationModal],
["DropdownMenu", LazyDropdownMenu],
["FlowStepper", LazyFlowStepper],
["GlobalModalContainer", LazyGlobalModalContainer],
["HamburgerMenu", LazyHamburgerMenu],
["InputCustom", LazyInputCustom],
["InputRange", LazyInputRange],
["IntroVideoModal", LazyIntroVideoModal],
["Loading", LazyLoading],
["Logo", LazyLogo],
["LogoName", LazyLogoName],
["ModalContainer", LazyModalContainer],
["PaddleInlineCheckout", LazyPaddleInlineCheckout],
["Page", LazyPage],
["PageLoading", LazyPageLoading],
["PlanSelector", LazyPlanSelector],
["ProgressBar", LazyProgressBar],
["ProgressStepper", LazyProgressStepper],
["Scrim", LazyScrim],
["SearchableDropdown", LazySearchableDropdown],
["TablePagination", LazyTablePagination],
["TextAreaCustom", LazyTextAreaCustom],
["Toast", LazyToast],
["TrialBanner", LazyTrialBanner],
["TurnstileWidget", LazyTurnstileWidget],
["TypedConfirmationModal", LazyTypedConfirmationModal],
["UnsavedChangesModal", LazyUnsavedChangesModal],
["UpgradePlanModal", LazyUpgradePlanModal],
["AuditBusinessImpact", LazyAuditBusinessImpact],
["AuditChallenges", LazyAuditChallenges],
["AuditCompanyDetails", LazyAuditCompanyDetails],
["AuditContainer", LazyAuditContainer],
["AuditPolicies", LazyAuditPolicies],
["AuditReport", LazyAuditReport],
["AuditStepper", LazyAuditStepper],
["AuditSummary", LazyAuditSummary],
["AuditWelcome", LazyAuditWelcome],
["AuditWelcomeInline", LazyAuditWelcomeInline],
["CostPerTechnicalHire", LazyCostPerTechnicalHire],
["DropdownQuestion", LazyDropdownQuestion],
["FaqModal", LazyFaqModal],
["FrequencyScale", LazyFrequencyScale],
["FrequencyScaleQuestion", LazyFrequencyScaleQuestion],
["HiringProcessCreate", LazyHiringProcessCreate],
["InterviewDuration", LazyInterviewDuration],
["InterviewLocation", LazyInterviewLocation],
["InterviewParticipantCount", LazyInterviewParticipantCount],
["InterviewType", LazyInterviewType],
["LongestTimeToHire", LazyLongestTimeToHire],
["MarketRateTarget", LazyMarketRateTarget],
["NumberOfEmployees", LazyNumberOfEmployees],
["NumberOfRecruiters", LazyNumberOfRecruiters],
["NumberOfTechnicalEmployees", LazyNumberOfTechnicalEmployees],
["NumberOfTechnicalHiresLast12Months", LazyNumberOfTechnicalHiresLast12Months],
["NumberOfTechnicalHiresNext12Months", LazyNumberOfTechnicalHiresNext12Months],
["NumberQuestion", LazyNumberQuestion],
["OfferAcceptanceRate", LazyOfferAcceptanceRate],
["ProcessStageTable", LazyProcessStageTable],
["ProgressDial", LazyProgressDial],
["RadioGroup", LazyRadioGroup],
["SectionHeader", LazySectionHeader],
["SelectionCard", LazySelectionCard],
["SelectionCardContainer", LazySelectionCardContainer],
["Step0", LazyStep0],
["Step1", LazyStep1],
["Step2", LazyStep2],
["Step3", LazyStep3],
["Step4", LazyStep4],
["Step5", LazyStep5],
["Step7", LazyStep7],
["SubQuestionGroup", LazySubQuestionGroup],
["TimeToFillPosition", LazyTimeToFillPosition],
["YesNoAuditQuestionsContainer", LazyYesNoAuditQuestionsContainer],
["YesNoButtons", LazyYesNoButtons],
["YesNoQuestion", LazyYesNoQuestion],
["YesNoSelect", LazyYesNoSelect],
["SSOLoginButton", LazySSOLoginButton],
["AiBadge", LazyAiBadge],
["InfoTooltip", LazyInfoTooltip],
["NotificationDropdown", LazyNotificationDropdown],
["DashboardActionCard", LazyDashboardActionCard],
["EmptyStateCard", LazyEmptyStateCard],
["KpiCard", LazyKpiCard],
["RecentDocumentCard", LazyRecentDocumentCard],
["FeedbackModal", LazyFeedbackModal],
["DynamicForm", LazyDynamicForm],
["FormContainer", LazyFormContainer],
["FormFlag", LazyFormFlag],
["CompanyInfoSchema", LazyCompanyInfoSchema],
["PositionSchema1", LazyPositionSchema1],
["HelpPage", LazyHelpPage],
["TabHeading", LazyTabHeading],
["AuditImprovementComparison", LazyAuditImprovementComparison],
["CandidatePacket", LazyCandidatePacket],
["FeatureCard", LazyFeatureCard],
["HiringKitTabs", LazyHiringKitTabs],
["IntakeSummary", LazyIntakeSummary],
["InternalSummaryReport", LazyInternalSummaryReport],
["InterviewPlanSummary", LazyInterviewPlanSummary],
["InterviewStagesPdf", LazyInterviewStagesPdf],
["JobDescriptionModal", LazyJobDescriptionModal],
["LinkedInBooleanSearch", LazyLinkedInBooleanSearch],
["LinkedinBooleanSearchModal", LazyLinkedinBooleanSearchModal],
["MetricBox", LazyMetricBox],
["PdfBrand", LazyPdfBrand],
["PdfSectionChecklist", LazyPdfSectionChecklist],
["PdfSensitiveControls", LazyPdfSensitiveControls],
["PdfSnapshotDialog", LazyPdfSnapshotDialog],
["RiskWarningSlideover", LazyRiskWarningSlideover],
["RolePlanPdfSections", LazyRolePlanPdfSections],
["RolePlanSave", LazyRolePlanSave],
["TabContent", LazyTabContent],
["UsefulLinks", LazyUsefulLinks],
["InterviewStrategyTable", LazyInterviewStrategyTable],
["InterviewTypeCard", LazyInterviewTypeCard],
["MatrixSlider", LazyMatrixSlider],
["MatrixTable", LazyMatrixTable],
["ModelCard", LazyModelCard],
["RegionCard", LazyRegionCard],
["WorldMap", LazyWorldMap],
["CheckerPanel", LazyCheckerPanel],
["IntakeComplete", LazyIntakeComplete],
["IntakeFormField", LazyIntakeFormField],
["IntakeFormSection", LazyIntakeFormSection],
["IntakeLayout", LazyIntakeLayout],
["IntakeMobileSteps", LazyIntakeMobileSteps],
["IntakeSidebar", LazyIntakeSidebar],
["IntakeStepModal", LazyIntakeStepModal],
["IntakeStepper", LazyIntakeStepper],
["IntakeWelcome", LazyIntakeWelcome],
["InterviewPlanStep", LazyInterviewPlanStep],
["RadioSelect", LazyRadioSelect],
["ReadOnlyIntakeSections", LazyReadOnlyIntakeSections],
["SalaryMarketCheck", LazySalaryMarketCheck],
["YesNoRadio", LazyYesNoRadio],
["FocusAreaConditionalSection", LazyFocusAreaConditionalSection],
["ImpactModelInputs", LazyImpactModelInputs],
["ImpactModelSummary", LazyImpactModelSummary],
["InterviewMetricsRow", LazyInterviewMetricsRow],
["InterviewPlanReadyModal", LazyInterviewPlanReadyModal],
["InterviewPlanSelection", LazyInterviewPlanSelection],
["InterviewStageCard", LazyInterviewStageCard],
["InterviewStageModal", LazyInterviewStageModal],
["YogenPlanConfirmModal", LazyYogenPlanConfirmModal],
["LeftNav", LazyLeftNav],
["LeftNavLink", LazyLeftNavLink],
["NavBar", LazyNavBar],
["ProfileMenu", LazyProfileMenu],
["JobDescription", LazyJobDescription],
["UnicornCheckerModal", LazyUnicornCheckerModal],
["UnicornCheckerPanel", LazyUnicornCheckerPanel],
["AddHiringProcessModal", LazyAddHiringProcessModal],
["HiringProcessDisplay", LazyHiringProcessDisplay],
["CompanyInfo", LazyCompanyInfo],
["CompanyInfoEditModal", LazyCompanyInfoEditModal],
["CompanyInfoIntakeDisplay", LazyCompanyInfoIntakeDisplay],
["CompanyInfoIntakeForm", LazyCompanyInfoIntakeForm],
["CompanyInfoProfileSection", LazyCompanyInfoProfileSection],
["OrgInfo", LazyOrgInfo],
["ProfileContainer", LazyProfileContainer],
["TeamInfo", LazyTeamInfo],
["UserInfo", LazyUserInfo],
["Administration", LazyAdministration],
["AuditLogs", LazyAuditLogs],
["ChangePassword", LazyChangePassword],
["DeleteAccount", LazyDeleteAccount],
["InviteUserModal", LazyInviteUserModal],
["MFASettings", LazyMFASettings],
["ManageUsers", LazyManageUsers],
["MemberAccessEditor", LazyMemberAccessEditor],
["MemberAccessModal", LazyMemberAccessModal],
["OIDCSettings", LazyOIDCSettings],
["OrgSettings", LazyOrgSettings],
["PrivacySettings", LazyPrivacySettings],
["RevokeAccessModal", LazyRevokeAccessModal],
["RolesPermissionsModal", LazyRolesPermissionsModal],
["SeatLimitModal", LazySeatLimitModal],
["SecuritySettings", LazySecuritySettings],
["SessionTimeoutSettings", LazySessionTimeoutSettings],
["TeamCreateModal", LazyTeamCreateModal],
["TeamMembersManager", LazyTeamMembersManager],
["MockInterviewStepper", LazyMockInterviewStepper],
["CandidateStatus", LazyCandidateStatus],
["ChatWindow", LazyChatWindow],
["DifficInterviewtoolkit", LazyDifficInterviewtoolkit],
["HeartRateIndicator", LazyHeartRateIndicator],
["Interviewtoolkit", LazyInterviewtoolkit],
["TimeRemaining", LazyTimeRemaining],
["MockInterviewCandidateStep", LazyMockInterviewCandidateStep],
["MockInterviewDetailsStep", LazyMockInterviewDetailsStep],
["MockInterviewRoleStep", LazyMockInterviewRoleStep],
["VChipWrapper", LazyVChipWrapper],
["VDataTableWrapper", LazyVDataTableWrapper],
["VIconWrapper", LazyVIconWrapper],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
